const TableTitleVerification = {
  title: 'Grupos Checklist',
  placeholder: 'Pesquisar por grupos do checklist',
  Typography: 'Nenhum resultado encontrado'
};

export default TableTitleVerification;

